<template>
  <v-dialog v-model="dialog"       :fullscreen="$vuetify.display.smAndDown"
 persistent>
    <v-card>
      <v-card-title class="redColor d-flex">
        <span v-if="edit == true" class="headline text-white">
          {{ $t("parts.insert_parts.form.edit_temporary_part") }}
          {{
            temporaryPart._id.slice(
              temporaryPart._id.length - 4,
              temporaryPart._id.length,
            )
          }}
        </span>
        <span
          v-if="edit == false && additionalPart == false"
          class="headline text-white"
          >{{ $t("parts.insert_parts.form.create_temporary_part") }}</span
        >
        <span v-if="edit == false && additionalPart == true" class="headline">{{
          $t("parts.insert_parts.form.create_additional_part")
        }}</span>
        <v-spacer />
        <v-btn variant="outlined" icon color="white" @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- Stage 6 slice 4: display only; never part of the save path. -->
        <car-body-released-banner v-if="dialog" :car-id="bannerCarId" />
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-row wrap>
              <v-col cols="12" md="12" lg="12">
                <v-col cols="12" md="12" lg="12" class="d-md-flex d-lg-flex">
                  <div>
                    <h2 class="mt-4">
                      {{ $t("parts.insert_parts.upload_label") }}
                    </h2>
                    <input
                      ref="fileInput"
                      type="file"
                      accept="image/*"
                      @change="handleFileUpload"
                    />
                    <v-form class="mt-2">
                      <v-row
                        v-if="loadingClassify"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="50"
                          color="red-darken-2"
                        />
                      </v-row>

                      <span
                        v-if="
                          temporaryPart && temporaryPart.extractedLabelOemCodeAI
                        "
                      >
                        <strong>{{ $t("oem_from_label") }}</strong>
                        {{ temporaryPart.extractedLabelOemCodeAI }}
                      </span>
                      <br />
                      <span v-if="dataFound" class="ml-2 text-danger">{{
                        $t("parts.insert_parts.check_found_data")
                      }}</span>
                    </v-form>
                  </div>

                  <div>
                    <v-card
                      v-if="image.src"
                      flat
                      tile
                      draggable="true"
                      :data-index="index"
                      @mouseenter="hoverIndex = index"
                      @mouseleave="hoverIndex = null"
                    >
                      <v-img
                        v-if="image.src"
                        :src="image.src"
                        :width="$vuetify.display.smAndDown ? '150px' : '300px'"
                        class="mx-1"
                      >
                        <v-row
                          v-if="hoverIndex === index"
                          class="ma-1 d-flex justify-space-between"
                        >
                          <v-icon
                            size="x-large"
                            color="primary"
                            class="pointer"
                            @click="viewImage('dataUrl', image.src)"
                          >
                            mdi-image
                          </v-icon>
                          <v-icon
                            size="x-large"
                            color="red"
                            class="pointer"
                            @click="deleteImageTemp(image)"
                          >
                            mdi-delete-forever
                          </v-icon>
                        </v-row>
                      </v-img>
                    </v-card>
                    <v-card
                      v-else-if="temporaryPart.oemLableDetails"
                      flat
                      tile
                      draggable="true"
                      :data-index="index"
                      @dragstart="dragStartHandler"
                      @dragover.prevent
                      @drop="dropHandler"
                      @dragend="dragEndHandler"
                      @mouseenter="hoverIndex = index"
                      @mouseleave="hoverIndex = null"
                    >
                      <v-img
                        v-if="part.oemLableDetails"
                        :src="`https://leko-tech.fra1.cdn.digitaloceanspaces.com/${temporaryPart.oemLableDetails}`"
                        :width="$vuetify.display.xs ? '150px' : '300px'"
                        class="mx-1"
                      >
                        <v-row
                          v-if="hoverIndex === index"
                          class="ma-1 d-flex justify-space-between"
                        >
                          <v-icon
                            size="x-large"
                            color="primary"
                            class="pointer"
                            @click="
                              viewImage('label', temporaryPart.oemLableDetails)
                            "
                          >
                            mdi-image
                          </v-icon>

                          <v-icon
                            size="x-large"
                            color="red"
                            class="pointer"
                            @click="
                              deleteImageTemp(
                                temporaryPart._id,
                                temporaryPart.oemLableDetails,
                              )
                            "
                          >
                            mdi-delete-forever
                          </v-icon>
                        </v-row>
                      </v-img>
                    </v-card>
                    <div v-else class="default-image-text">
                      <!-- Test image will be shown here -->
                    </div>
                  </div>
                </v-col>
              </v-col>

              <!-------------------------------------SHIPMENT-------------------------------------->
              <v-col cols="12" sm="5" md="7">
                <!--SHIPMENT SELECTION-->
                <v-autocomplete
                  v-model="temporaryPart.shipment_id"
                  :items="shipments"
                  :rules="rules.required"
                  :label="$t('parts.insert_parts.form.shipment')"
                  color="red-darken-1"
                  item-title="name"
                  item-value="_id"
                />
              </v-col>
              <v-col cols="12" sm="7" md="5">
                <v-row align-center justify-center row wrap>
                  <!--NEW SHIPMENT-->
                  <v-btn
                    color="success"
                    variant="flat"
                    small
                    class="mr-1 mt-5"
                    @click="newShipment"
                  >
                    {{ $t("parts.insert_parts.form.new_shipment") }}
                  </v-btn>
                  <!--SCAN SHIPMENT-->
                  <v-btn
                    color="primary"
                    class="mt-5"
                    variant="flat"
                    small
                    @click="scanShipment"
                  >
                    {{ $t("parts.insert_parts.form.scan_shipment") }}
                  </v-btn>
                </v-row>
              </v-col>
              <!--------------------------------------NOTES---------------------------------------->
              <v-col cols="12" sm="8" lg="8" md="8">
                <v-text-field
                  v-model="temporaryPart.notes"
                  :label="$t('parts.insert_parts.form.notes')"
                  color="red-darken-1"
                />
              </v-col>
              <!------------------------------------PART POSITION----------------------------------->
              <v-col cols="12" sm="4" lg="4" md="4">
                <v-select
                  v-model="temporaryPart.positionCode"
                  :items="[
                    {
                      title:
                        $t('neutral').charAt(0).toUpperCase() +
                        $t('neutral').slice(1),
                      value: 'S000',
                    },
                    {
                      title:
                        $t('left').charAt(0).toUpperCase() +
                        $t('left').slice(1),
                      value: 'S001',
                    },
                    {
                      title:
                        $t('right').charAt(0).toUpperCase() +
                        $t('right').slice(1),
                      value: 'S002',
                    },
                  ]"
                  :label="$t('parts.insert_parts.form.part_position')"
                  color="red-darken-1"
                  clearable
                />
              </v-col>
              <!----------------------------------INTERNAL NOTES----------------------------------->
              <v-col cols="12">
                <v-text-field
                  v-model="temporaryPart.internal_notes"
                  :label="$t('parts.insert_parts.form.internal_notes')"
                  color="red-darken-1"
                />
              </v-col>
              <!------------------------------------LEKO NOTES------------------------------------->
              <v-col cols="12">
                <v-text-field
                  v-model="temporaryPart.leko_notes"
                  :label="$t('parts.insert_parts.form.leko_notes')"
                  color="red-darken-1"
                />
              </v-col>
              <!---------------------------------------BRAND--------------------------------------->
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="temporaryPart.brand"
                  :label="$t('parts.insert_parts.form.brand')"
                  color="red-darken-1"
                />
              </v-col>
              <!-------------------------------------OEM CODES------------------------------------->
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="oemCode"
                  :label="$t('parts.insert_parts.form.oem_code')"
                  color="red-darken-1"
                  append-icon="mdi-plus"
                  @keyup.enter="addOemCode()"
                  @click:append="addOemCode()"
                />
              </v-col>
              <!--------------------------------------NR PRA--------------------------------------->
              <v-col cols="12" sm="4" lg="4" md="4">
                <v-text-field
                  v-model="temporaryPart.pra"
                  :label="$t('parts.insert_parts.form.pra')"
                  color="red-darken-1"
                />
              </v-col>

              <!--------------------------------------CONDITION--------------------------------------->
              <v-col cols="6" sm="2" lg="2" md="2" class="part-export-col">
                <div class="part-export-field">
                  <div class="part-export-field__header">
                    {{ $t("parts.insert_parts.form.condition") }}
                  </div>
                  <v-checkbox
                    v-model="temporaryPart.isNewPart"
                    :label="$t('parts.insert_parts.form.new')"
                    color="red-darken-3"
                    hide-details
                    density="compact"
                    class="part-export-field__checkbox"
                  />
                </div>
              </v-col>
              <!--------------------------------------EXPORT EBAY / RR--------------------------------------->
              <export-marketplaces
                v-model:export-ebay="temporaryPart.exportEbay"
                v-model:rr-export="temporaryPart.rrExport"
                :part-institution-rr="!!temporaryPart.institution_id?.rr"
                cols="6"
                sm="2"
                md="2"
                lg="2"
              />
              <!--------------------------------INSERTED OEM CODES--------------------------------->
              <v-col
                v-if="
                  temporaryPart.oemCodes && temporaryPart.oemCodes.length > 0
                "
                cols="12"
                sm="6"
              >
                <div class="caption grey--text text--darken-1">
                  {{ $t("parts.insert_parts.form.oem_codes") }}
                </div>
                <v-chip
                  v-for="(item, index) in temporaryPart.oemCodes"
                  :key="index"
                >
                  {{ item }}
                  <v-icon right @click="removeOemCode(index)">
                    mdi-minus-circle-outline
                  </v-icon>
                </v-chip>
              </v-col>
              <!----------------------------------------------------------------------------------->
              <v-col cols="12">
                <v-row row wrap>
                  <!-----------------------------------EBAY CODE----------------------------------->
                  <v-col cols="12" md="4" lg="4" xs="4">
                    <v-text-field
                      v-model="temporaryPart.ebayCode"
                      :label="$t('parts.insert_parts.form.ebay_code')"
                      color="red-darken-1"
                    />
                  </v-col>
                  <!------------------------------------PRICE-------------------------------------->
                  <v-col cols="6" md="4" lg="4" xs="4">
                    <v-text-field
                      :model-value="temporaryPart.price"
                      :label="$t('parts.insert_parts.form.price')"
                      color="red-darken-1"
                      type="number"
                      step="0.01"
                      min="0"
                      max="10000"
                      :data-ok="temporaryPart.price"
                      oninput="if(this.value!==''&&Number(this.value)>10000){this.value=this.getAttribute('data-ok')??'';}else if(!this.validity.valid){this.value=this.getAttribute('data-ok')??'';}else{this.setAttribute('data-ok',this.value);}"
                      @update:model-value="temporaryPart.price = keepPriceIfValid($event, temporaryPart.price)"
                    />
                  </v-col>
                  <!--
                  <v-col cols="6" md="4" lg="4" xs="4">
                    <v-text-field
                      v-model="temporaryPart.cost"
                      :label="$t('parts.insert_parts.form.cost')"
                      color="red-darken-1"
                      type="number"
                      step="0.01"
                      min="0"
                      oninput="validity.valid||(value='');"
                    />
                  </v-col>
                -->
                  <v-col cols="6" md="4" lg="4" xs="4">
                    <v-select
                      v-model="selectedCurrency"
                      :items="currency"
                      :label="$t('parts.insert_parts.form.currency')"
                      color="red-darken-1"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <!--------------------------------------WEIGHT--------------------------------------->
              <v-col cols="7" xs="7">
                <v-text-field
                  v-model="weight.value"
                  :label="$t('parts.insert_parts.form.weight')"
                  color="red-darken-1"
                  type="number"
                  step="0.01"
                  min="0"
                  oninput="validity.valid || (value = '')"
                />
              </v-col>
              <v-col cols="5" xs="5">
                <v-select
                  v-model="weight.unit"
                  :items="weightUnits"
                  :label="$t('parts.insert_parts.form.unit')"
                  color="red-darken-1"
                />
              </v-col>
              <!--------------------------------------QUALITY-------------------------------------->
              <v-col cols="12">
                <v-select
                  v-model="temporaryPart.quality"
                  :label="$t('parts.insert_parts.form.quality')"
                  :items="qualities"
                  color="red-darken-1"
                  :item-title="() => ''"
                  item-value="_id"
                >
                  <!-- Dropdown list items -->
                  <template #item="{ item, props }">
                    <v-list-item v-bind="props">
                      <v-chip class="ma-1" size="small">
                        <v-rating
                          :model-value="item.raw.rating"
                          color="red"
                          background-color="red"
                          readonly
                          density="compact"
                        />
                      </v-chip>
                    </v-list-item>
                  </template>

                  <!-- Selected item display -->
                  <template #selection="{ item }">
                    <v-chip class="ma-1" size="small">
                      <v-rating
                        :model-value="item.raw.rating"
                        color="red"
                        background-color="red"
                        readonly
                        density="compact"
                      />
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <!-------------------------------------WARRANTY-------------------------------------->
              <v-col cols="12">
                <v-select
                  v-model="temporaryPart.warranty_id"
                  :items="warranties"
                  :label="$t('parts.insert_parts.form.warranty')"
                  color="red-darken-1"
                  :item-title="() => ''"
                  item-value="_id"
                >
                  <!-- Dropdown list items -->
                  <template #item="{ item, props }">
                    <v-list-item v-bind="props">
                      <v-list-item-title>
                        {{ item.raw.return_days / 86400 }}
                        {{ $t("warranties.days") }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>

                  <!-- Selected item display -->
                  <template #selection="{ item }">
                    <span>
                      {{ item.raw.return_days / 86400 }}
                      {{ $t("warranties.days") }}
                    </span>
                  </template>
                </v-select>
              </v-col>
              <!------------------------------CLASSIFICATION WITH AI------------------------------->
              <v-col cols="12">
                <v-text-field
                  v-model="temporaryPart.classificationWithAI"
                  :label="$t('parts.insert_parts.form.classification_with_ai')"
                  color="red-darken-1"
                />
              </v-col>
              <!------------------------------------REPOSITORY------------------------------------->
              <v-col cols="12">
                <repository-comp
                  ref="repositoryComponent"
                  :part="temporaryPart"
                  @location="setPartLocation"
                />
              </v-col>

              <!----------------------------------------KIT---------------------------------------->
              <v-col v-if="!additionalPart" cols="12">
                <v-row
                  align-center
                  justify-center
                  row
                  wrap
                  class="justify-center"
                >
                  <!--Kit-->
                  <v-col xs="6" sm="2">
                    <v-switch
                      v-model="temporaryPart.kit"
                      :label="$t('parts.insert_parts.form.kit')"
                      color="red-darken-1"
                    />
                  </v-col>
                  <!--Main Part-->
                  <v-col xs="6" sm="3">
                    <v-switch
                      v-model="temporaryPart.kit_main_part"
                      :disabled="!temporaryPart.kit"
                      :label="$t('parts.insert_parts.form.main_part')"
                      color="primary"
                    />
                  </v-col>
                  <!--Price-->
                  <v-col
                    v-if="temporaryPart.kit && temporaryPart.kit_main_part"
                    cols="12"
                    sm="3"
                  >
                    <v-text-field
                      v-model="temporaryPart.kit_price"
                      :label="$t('parts.insert_parts.form.kit_price')"
                      color="red-darken-1"
                      type="number"
                      min="0"
                      oninput="validity.valid || (value = '')"
                    />
                  </v-col>
                  <!--Scan Main Part-->
                  <v-col
                    v-if="temporaryPart.kit && !temporaryPart.kit_main_part"
                    xs="6"
                    sm="3"
                  >
                    <v-btn
                      :color="temporaryPart.kit_id ? 'green' : 'orange'"
                      variant="outlined"
                      @click="$emit('scan-main-part')"
                    >
                      {{ $t("parts.insert_parts.form.scan_main_part") }}
                      <v-icon right>
                        {{
                          temporaryPart.kit_id && temporaryPart.kit_id !== null
                            ? 'mdi-checkbox-marked-circle-outline"'
                            : "mdi-alert-outline"
                        }}
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <!--------------------------------------WEBCAM--------------------------------------->
              <v-col cols="12" class="d-flex justify-center">
                <div class="align-center">
                  <camera v-if="dialog" @take-picture="takePicture" />
                </div>
              </v-col>
              <!--------------------------------------IMAGES--------------------------------------->
              <v-col cols="12">
                <v-container grid-list-sm fluid>
                  <!--NEW PHOTOS-->
                  <div
                    :style="$vuetify.display.smAndDown ? 'overflow-x:scroll;-webkit-overflow-scrolling:touch;' : ''"
                  >
                    <v-row class="d-flex flex-nowrap" no-gutters>
                      <div
                        v-for="(data, index) in tempImages"
                        :key="index"
                        class="shrink"
                      >
                        <v-card
                          flat
                          tile
                          draggable="true"
                          :data-index="index"
                          @dragstart="dragStartHandler"
                          @dragover.prevent
                          @drop="dropHandler"
                          @dragend="dragEndHandler"
                          @mouseenter="hoverIndex = index"
                          @mouseleave="hoverIndex = null"
                        >
                          <v-img
                            :src="data.dataUrl"
                            :width="$vuetify.display.smAndDown ? '120px' : '150px'"
                            class="mx-1"
                          >
                            <v-row
                              class="ma-1 d-flex justify-space-between"
                            >
                              <v-icon
                                size="x-large"
                                color="primary"
                                class="pointer"
                                @click="viewImage('dataUrl', data.dataUrl)"
                              >
                                mdi-image
                              </v-icon>

                              <v-icon
                                v-if="!$vuetify.display.smAndDown || hoverIndex === index"
                                size="x-large"
                                color="orange"
                                class="pointer"
                                @click="openImageEditor('dataUrl', index, data)"
                              >
                                mdi-pencil
                              </v-icon>

                              <v-icon
                                v-if="data.originalDataUrl && (!$vuetify.display.smAndDown || hoverIndex === index)"
                                size="x-large"
                                color="orange-darken-2"
                                class="pointer"
                                @click="restoreTempOriginal(index)"
                              >
                                mdi-backup-restore
                              </v-icon>

                              <v-icon
                                size="x-large"
                                color="red"
                                class="pointer"
                                @click="deleteTempImage(index)"
                              >
                                mdi-delete-forever
                              </v-icon>
                            </v-row>
                          </v-img>
                        </v-card>
                      </div>
                    </v-row>
                  </div>
                  <!--EXISTING PHOTOS-->
                  <div
                    :style="$vuetify.display.smAndDown ? 'overflow-x:scroll;-webkit-overflow-scrolling:touch;' : ''"
                  >
                    <v-row class="d-flex flex-nowrap" no-gutters>
                      <div
                        v-for="(image, index) in temporaryPart.images"
                        :key="image.image"
                        class="shrink"
                      >
                        <v-card
                          flat
                          tile
                          draggable="true"
                          :data-index="index"
                          @dragstart="dragStartHandler"
                          @dragover.prevent
                          @drop="dropHandler"
                          @dragend="dragEndHandler"
                          @mouseenter="hoverIndex = index"
                          @mouseleave="hoverIndex = null"
                        >
                          <v-img
                            :src="`https://leko-tech.fra1.cdn.digitaloceanspaces.com/${image.thumb}`"
                            :width="$vuetify.display.smAndDown ? '120px' : '150px'"
                            class="mx-1"
                          >
                            <v-row
                              class="ma-1 d-flex justify-space-between"
                            >
                              <v-icon
                                size="x-large"
                                color="primary"
                                class="pointer"
                                @click="viewImage('string', image)"
                              >
                                mdi-image
                              </v-icon>

                              <v-icon
                                v-if="!$vuetify.display.smAndDown || hoverIndex === index"
                                size="x-large"
                                color="orange"
                                class="pointer"
                                @click="openImageEditor('string', index, image)"
                              >
                                mdi-pencil
                              </v-icon>

                              <v-icon
                                v-if="image.originalUrl && (!$vuetify.display.smAndDown || hoverIndex === index)"
                                size="x-large"
                                color="orange-darken-2"
                                class="pointer"
                                @click="restoreOriginalImage(index)"
                              >
                                mdi-backup-restore
                              </v-icon>

                              <v-icon
                                size="x-large"
                                color="red"
                                class="pointer"
                                @click="deleteImage(part._id, image, index)"
                              >
                                mdi-delete-forever
                              </v-icon>
                            </v-row>
                          </v-img>
                        </v-card>
                      </div>
                    </v-row>
                  </div>
                </v-container>

                <!-- <img-grid
                  :images="images"
                  @imagesChanged="updateImages"
                  @open="openImgDialog"
                  @delete="deleteImage"
                /> -->
              </v-col>
              <!----------------------------------AUDIO RECORDER----------------------------------->
              <!-- <v-col cols="12">
                <audio-recorder
                  v-if="dialog"
                  @record="record"
                  @delete="deleteRecording"
                />
              </v-col> -->
              <!----------------------------------------------------------------------------------->
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("parts.insert_parts.form.close") }}
        </v-btn>
        <v-btn
          :disabled="disabled"
          :loading="loading"
          color="green-darken-1"
          variant="outlined"
          @click="save"
        >
          {{ $t("parts.insert_parts.form.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import zoom from "../../utils/zoom";
import Repository from "../../components/InsertParts/repository.vue";
import Camera from "@/components/camera.vue";
import AudioRecorder from "@/components/audioRecorder.vue";
import ExportMarketplaces from "@/components/common/ExportMarketplaces.vue";
import CarBodyReleasedBanner from "@/components/Waste/carBodyReleasedBanner.vue";
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import { dataURLtoBlob } from "../../utils/files";

export default {
  components: {
    "repository-comp": Repository,
    camera: Camera,
    "audio-recorder": AudioRecorder,
    "export-marketplaces": ExportMarketplaces,
    "car-body-released-banner": CarBodyReleasedBanner,
  },
  props: ["hide"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    dialog: false,
    edit: false,
    valid: false,
    disabled: false,
    loading: false,
    additionalPart: false,
    showRepo: false,
    oemCode: null,
    currency: ["EUR"], // 'ALL'
    selectedCurrency: "EUR",
    weight: { value: 0, unit: "kg" },
    weightUnits: ["kg"],
    rules: {
      requiredLetters: [
        (v) => !!v || "Please fill this field",
        (v) => /[A-Za-z]/.test(v) || "Only letters are allowed",
      ],
      required: [(v) => !!v || "Please fill this field"],
    },
    temporaryPart: {},
    shipments: [],
    qualities: [],
    warranties: [],
    tempImages: [],
    recording: {},
    draggingIndex: -1,
    dropIndex: -1,
    image: {
      type: null,
      src: null,
      url: null,
    },
    imageValid: false,
    rotation: 0,
    img: null,
    loadingClassify: false,
    dataFound: false,
    hoverIndex: null,
  }),
  computed: {
    // The part's car id for the car-body banner: car_id is an id or a populated car.
    bannerCarId() {
      const car = this.temporaryPart && this.temporaryPart.car_id;
      if (!car) return null;
      return String(typeof car === "object" ? car._id || "" : car) || null;
    },
    server() {
      return this.$serverUri;
    },
    hideDialog() {
      return this.$props.hide;
    },
  },
  watch: {
    hideDialog(value) {
      if (value) {
        this.dialog = false;
      } else {
        this.dialog = true;
      }
    },
    temporaryPart: {
      handler(value) {
        if (value.kit === false) {
          this.temporaryPart.kit_main_part = false;
        }
        // Disable save button.
        if (
          value.kit === true &&
          value.kit_main_part === false &&
          !value.kit_id
        ) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    keepPriceIfValid(value, current) {
      if (value === "" || value == null) return value;
      const n = Number(value);
      if (!Number.isFinite(n) || n > 10000) return current;
      return value;
    },
    open(edit, additional, data) {
      this.getShipments();
      this.getQualities();
      this.getWarranties();
      this.openRepository(data);
      this.temporaryPart = data;
      if (this.temporaryPart.rrExport !== false) this.temporaryPart.rrExport = true;
      if (this.temporaryPart.exportEbay !== false) this.temporaryPart.exportEbay = true;
      if (data.weight) this.weight = data.weight;
      this.edit = edit;
      this.additionalPart = additional;
      this.dialog = true;
      this.part = data;
      this.dataFound = false;
    },
    close() {
      this.clearPartLocation();
      this.temporaryPart = {};
      this.shipments = [];
      this.qualities = [];
      this.warranties = [];
      this.tempImages = [];
      this.recording = {};
      this.edit = false;
      this.additionalPart = false;
      this.weight = { value: 0, unit: "kg" };
      this.loading = false;
      this.dialog = false;
      this.image.src = null;
      this.img = null;
      this.dataFound = false;
      this.$emit("close");
    },
    save() {
      this.loading = true;
      const formData = new FormData();

      this.temporaryPart.currency = this.selectedCurrency;
      this.temporaryPart.weight = this.weight;

      if (this.temporaryPart.isEmpty) this.temporaryPart.initialSave = true;
      else this.temporaryPart.initialSave = false;

      this.temporaryPart.currentUser = this.$store.getters.userId;
      this.temporaryPart.isEmpty = false;

      // APPEND PHOTOS
      if (this.tempImages.length > 0) {
        this.tempImages.forEach((image) => {
          formData.append("photos", image.blob, image.title);
        });
      }
      if (this.img) {
        formData.append("oemLableDetails", this.img, "oemLabel.png");
      }

      formData.append(
        "data",
        JSON.stringify({
          part: this.temporaryPart,
          user: this.$store.getters.userId,
          replacedImageOriginals: this.collectReplacedImageOriginals(),
        }),
      );

      if (Object.keys(this.recording).length > 0 && this.recording.blob) {
        formData.append("audio", this.recording.blob, "record.ogg");
      }

      postRequest
        .formData(
          "/temporary-part/insert/",
          `id=${this.temporaryPart._id}`,
          formData,
        )
        .then((response) => {
          this.$emit("save");
          this.close();
        })
        .catch(() => {
          this.close();
        });
    },
    deleteImageTemp(image) {
      this.image = {
        type: null,
        src: null,
        url: null,
      };
      this.img = null;
      this.part.oemLableDetails = null;
      this.temporaryPart.oemLableDetails = null;
    },
    getShipments() {
      getRequest(
        "/shipment",
        `role=${this.$store.getters.role}&institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.shipments = response.shipments;
        })
        .catch(() => {});
    },
    getQualities() {
      getRequest("/quality/")
        .then((response) => {
          this.qualities = response.qualities;
        })
        .catch(() => {});
    },
    getWarranties() {
      getRequest("/warranty")
        .then((response) => {
          this.warranties = response.warranties;
        })
        .catch(() => {});
    },
    takePicture(data) {
      const randomString = Math.random().toString(36).substring(9);
      const imgObj = {
        title: `${randomString}-photo${this.tempImages.length}.png`,
        dataUrl: data.dataUrl,
        blob: data.blob,
      };
      this.tempImages.push(imgObj);
    },
    record(data) {
      this.recording = data;
      this.temporaryPart.audio = { exists: true, title: "record.ogg" };
    },
    deleteRecording() {
      this.recording = {};
      this.temporaryPart.audio = { exists: false, title: null };
    },
    viewImage(type, data) {
      this.$emit("open-img-dialog", { type, data });
    },
    deleteImage(index) {
      this.temporaryPart.images.splice(index, 1);
    },
    deleteTempImage(index) {
      this.tempImages.splice(index, 1);
    },
    openImageEditor(type, index, data) {
      this.$emit("open-img-editor", { type, index, data });
    },
    setEditedImage(image) {
      if (image.restoreOriginal) {
        if (image.type === "dataUrl") {
          this.restoreTempOriginal(image.index, image);
          return;
        }
        this.restoreOriginalImage(image.index, image);
        return;
      }
      let type = "";
      // Remove the existing unedited image.
      if (image.type === "dataUrl") {
        type = "n";
        this.deleteTempImage(image.index);
      }
      if (image.type === "string") {
        type = "e";
        this.deleteImage(image.index);
      }
      // Add the edited one.
      this.tempImages.push({
        title: `${type}-${image.index}-${image.title}`,
        dataUrl: image.dataUrl,
        blob: image.blob,
        originalUrl: image.originalUrl || null,
        originalThumb: image.originalThumb || null,
        originalDataUrl: image.originalDataUrl || null,
        originalBlob: image.originalBlob || null,
      });
    },
    collectReplacedImageOriginals() {
      const originals = {};
      this.tempImages.forEach((image) => {
        if (!image.originalUrl) return;
        const parts = (image.title || "").split("-");
        if (parts[0] === "e" && parts[1] !== undefined) {
          originals[parts[1]] = {
            originalUrl: image.originalUrl,
            originalThumb: image.originalThumb || null,
          };
        }
      });
      return originals;
    },
    restoreOriginalImage(index, payload = null) {
      const image = this.temporaryPart.images[index];
      const originalUrl = (payload && payload.originalUrl) || (image && image.originalUrl);
      if (!image || !originalUrl) return;
      this.temporaryPart.images.splice(index, 1, {
        ...image,
        image: originalUrl,
        thumb:
          (payload && payload.originalThumb) ||
          image.originalThumb ||
          originalUrl,
        originalUrl: null,
        originalThumb: null,
      });
    },
    restoreTempOriginal(index, payload = null) {
      const image = this.tempImages[index];
      const originalDataUrl =
        (payload && payload.originalDataUrl) ||
        (image && image.originalDataUrl);
      if (!image || !originalDataUrl) return;
      this.tempImages.splice(index, 1, {
        ...image,
        dataUrl: originalDataUrl,
        blob: (payload && payload.originalBlob) || image.originalBlob,
        originalUrl: null,
        originalThumb: null,
        originalDataUrl: null,
        originalBlob: null,
      });
    },
    openRepository(data) {
      const { repositoryComponent } = this.$refs;
      if (
        repositoryComponent &&
        typeof repositoryComponent.open === "function"
      ) {
        repositoryComponent.open(data);
      } else {
        //
      }
    },
    setPartLocation(data) {
      this.temporaryPart.repository_id = data.repository_id;
      this.temporaryPart.room_id = data.room_id;
      this.temporaryPart.location_id = data.location_id;
      this.temporaryPart.shelf_id = data.shelf_id;
    },
    clearPartLocation() {
      const { repositoryComponent } = this.$refs;
      repositoryComponent.clear();
    },
    newShipment() {
      this.$emit("new-shipment");
    },
    scanShipment() {
      this.$emit("scan-shipment");
    },
    setShipment(shipmentId) {
      this.temporaryPart.shipment_id = shipmentId;
    },
    hideEditDialog(value) {
      if (value) this.dialog = false;
      else this.dialog = true;
    },
    setMainPart(data) {
      this.temporaryPart.kit_id = data;
    },
    addOemCode() {
      this.temporaryPart.oemCodes.push(this.oemCode);
      // set the first oemcode as ebay code
      [this.temporaryPart.ebayCode] = this.temporaryPart.oemCodes;
      this.oemCode = null;
    },
    removeOemCode(index) {
      this.temporaryPart.oemCodes.splice(index, 1);
    },
    dragStartHandler(e) {
      this.draggingIndex = parseInt(
        e.currentTarget.getAttribute("data-index"),
        10,
      );
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/html", null);
    },
    dropHandler(e) {
      this.dropIndex = parseInt(e.currentTarget.getAttribute("data-index"), 10);
      if (this.draggingIndex !== this.dropIndex) {
        const draggedImage = this.part.images[this.draggingIndex];
        this.part.images.splice(this.draggingIndex, 1);
        this.part.images.splice(this.dropIndex, 0, draggedImage);
      }
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },
    dragEndHandler() {
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },
    handleFileUpload() {
      // Get the file input element using the ref
      const { fileInput } = this.$refs;

      if (fileInput.files.length > 0) {
        const image = fileInput.files[0];
        this.img = image;
        const reader = new FileReader();
        reader.onload = (event) => {
          this.image = { type: "file", src: event.target.result, url: null };
          this.getImageDetails();
        };
        reader.readAsDataURL(image);
      }
    },
    getLinkedCarHints() {
      // Prefer new `car` field (string brand/model/version); fall back to nested car_id
      const car =
        this.temporaryPart?.car ||
        (this.temporaryPart?.car_id &&
        typeof this.temporaryPart.car_id === "object"
          ? this.temporaryPart.car_id
          : null);
      if (!car) {
        return { brand: "", model: "", version: "", notes: "" };
      }
      const brand =
        typeof car.brand === "string"
          ? car.brand.trim()
          : (car.brand?.title || "").trim();
      const model =
        typeof car.model === "string"
          ? car.model.trim()
          : (
              car.model?.fullDescription ||
              car.model?.description ||
              ""
            ).trim();
      const version =
        typeof car.version === "string"
          ? car.version.trim()
          : (
              car.version?.fullDescription ||
              car.version?.description ||
              ""
            ).trim();
      return {
        brand,
        model,
        version,
        notes: (this.temporaryPart?.notes || "").trim(),
      };
    },
    async getImageDetails() {
      if (!this.part.oemLableDetails && !this.image.src) {
        return;
      }
      this.loadingClassify = true;
      try {
        const { brand, model, version, notes } = this.getLinkedCarHints();
        let payload;
        const config = {};
        if (this.image.type === "file") {
          // Send file as FormData — do not set Content-Type (boundary must be set by axios)
          payload = new FormData();
          payload.append(
            "image",
            dataURLtoBlob(this.image.src),
            "uploaded-image.jpg",
          );
          if (brand) payload.append("brand", brand);
          if (model) payload.append("model", model);
          if (version) payload.append("version", version);
          if (notes) payload.append("notes", notes);
        } else {
          // Send URL as JSON; omit empty optional hints
          payload = {
            image: `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${this.part.oemLableDetails}`,
            ...(brand && { brand }),
            ...(model && { model }),
            ...(version && { version }),
            ...(notes && { notes }),
          };
        }
        const response = await axios.post(
          // 'https://oemlabeldetectionv4-97815853843.us-central1.run.app/get-image-detail', // gemini 1.5
          "https://new-extract-model-v2-97815853843.us-central1.run.app/get-image-detail", // gemini 2.5
          payload,
          config,
        );
        if (response && response.data && response.data.data) {
          const text = String(response.data.data).trim();
          if (
            !text ||
            /error|exception|server error|failed/i.test(text) ||
            /^\s*[\{\[]/.test(text)
          ) {
            this.loadingClassify = false;
            return;
          }
          this.dataFound = true;
          const lines = response.data.data.split("\n");

          let extractedBrand = "";
          let oem = "";
          lines.forEach((line, index) => {
            if (line.trim() === "Manufacturer:" && lines[index + 1]) {
              extractedBrand = lines[index + 1].trim();
            }
            if (line.trim() === "OEM Code:" && lines[index + 1]) {
              oem = lines[index + 1].trim();
              oem = oem.replace(/-/g, "").replace(/\s+/g, "");
            }
          });
          if (extractedBrand != null && extractedBrand !== "-") {
            this.temporaryPart.brand = extractedBrand;
          }
          if (
            oem != null &&
            oem !== "" &&
            oem !== "-" &&
            this.temporaryPart.extractedLabelOemCodeAI != oem
          ) {
            this.temporaryPart.extractedLabelOemCodeAI = oem;
          }
        }
      } catch {
      } finally {
        this.loadingClassify = false;
      }
    },
    zoomIn(event) {
      zoom.zoomIn(2.4, event, this.rotation);
      const img = event.target;

      img.classList.add("zoomed");
    },
    zoomOut(event) {
      zoom.zoomOut(event, this.rotation);
      const img = event.target;

      img.classList.remove("zoomed");
    },
  },
};
</script>
<style scoped>
.text-danger {
  color: red !important;
  text-decoration: underline;
}
</style>
